<template>
  <CRow>
    <CCard class="editorhtml col p-0">
      <CCardHeader class="bg-gray-200 px-5 pt-4">
        <section class="d-flex justify-content-between align-items-end">
          <h6 class="m-0 p-0 font-weight-normal">{{ $t('templates.editorHtml.text1') }}</h6>
          <div class="card-header-actions">
            <CForm inline>
              <CSelect
                label="theme:"
                size="sm"
                class="ml-auto"
                addLabelClasses="mx-3"
                :value.sync="selectedTheme"
                :options="['eclipse', 'material']"
                custom
              />
            </CForm>
          </div>
        </section>
      </CCardHeader>
      <CCardBody class="bg-gray-200 px-5 pb-5">
        <VueCodeMirror ref="codeMirrorComponent" v-model="code" :options="editorOptions" />
      </CCardBody>
      <CCardFooter class="mt-4">
        <CForm inline>
          <div v-if="code">
            <CButton class="px-4 py-2 btn-white" @click="modal = !modal">{{ $t('templates.editorHtml.buttom.preview') }}</CButton>
          </div>
          <div>
            <CButton class="px-4 py-2 btn-primary mx-3 text-uppercase" @click="confirm">{{ $t('templates.editorHtml.buttom.confirm') }}</CButton>
          </div>
          <div>
            <transition name="fade" v-if="popUpCancel">
              <div class="dataTable__popUp popUp" @click.stop.stop>
                <div class="popUp__body shadow-sm">
                  <ConfirmationDelete
                    :title="$t('templates.editTemplate.cancel-description.title')"
                    :description="$t('templates.editTemplate.cancel-description.description')"
                    @confirm="confirmCancel"
                    @cancel="closePopUpCancel"
                  />
                </div>
              </div>
            </transition>
            <CButton class="px-0 py-2  text-uppercase" @click.stop="popUpCancel = !popUpCancel">{{
              $t('templates.editorHtml.buttom.cancel')
            }}</CButton>
          </div>
        </CForm>
      </CCardFooter>
      <CModal :title="template.name" color="secundary" :show.sync="modal" size="xl">
        <iframe ref="iframeModal" width="100%" height="700px" frameborder="0"></iframe>
      </CModal>
    </CCard>
  </CRow>
</template>

<script>
import { getItem, setItem } from '../utils/StorageManager'
import ConfirmationDelete from '@/components/ConfirmationDelete'

import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/material.css'
import 'codemirror/theme/eclipse.css'
import 'codemirror/mode/markdown/markdown'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/mode/xml/xml'

export default {
  name: 'CodeEditors',
  components: {
    VueCodeMirror: codemirror,
    ConfirmationDelete,
  },
  props: {
    customField: {
      type: String,
    },
    subscribeText: {
      type: String,
    },
    template: {
      type: Object,
      default: () => {
        return {
          name: '',
          code: ``,
        }
      },
    },
  },
  data() {
    return {
      selectedMode: 'xml',
      selectedTheme: 'eclipse',
      modal: false,
      code: null,
      popUpCancel: false,
    }
  },
  computed: {
    codemirrorInstance() {
      return this.$refs.codeMirrorComponent.codemirror
    },

    editorOptions() {
      return {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: true,
        lineWrapping: true,
        line: true,
        theme: this.selectedTheme,
        autofocus: true,
      }
    },
  },
  mounted() {
    this.$root.$on('update-close-popup', () => {
      this.closePopUpCancel()
    })

    this.selectedTheme = getItem('theme-html-editor')

    this.templateCode()

    if (this.codemirrorInstance.options.autofocus) {
      this.codemirrorInstance.setSize('100%', '50vh')
      this.codemirrorInstance.focus()
    }
  },

  destroyed() {
    this.$root.$off('update-close-popup')
  },

  methods: {
    insertHtmlInIframe(content) {
      this.messages = []

      try {
        const IFRAME = this.$refs.iframeModal.contentWindow.document
        IFRAME.close('')
        IFRAME.close()
        IFRAME.write(content)
      } catch (error) {
        this.messages.push({
          status: 'danger',
          text: error,
        })
      }
    },

    closePopUpCancel() {
      this.popUpCancel = false
      // this.$emit('editor-html-cancel')
    },

    confirm() {
      //TODO repensar quando hover mais linguas
      this.code.indexOf('https://UNSUB_LINK_EN') > -1 || this.code.indexOf('https://UNSUB_LINK_PT') > -1
        ? this.$emit('confirm', { isInvalid: false, code: this.code })
        : this.$emit('confirm', { isInvalid: true, text: 'ADD_UNSUBSCRIBE' })
    },

    confirmCancel() {
      if (this.$route.params.campaignId) {
        this.goToCampaign(this.template)
        return
      }

      this.$router.push({ name: 'template-emails' })
    },

    goToCampaign(template) {
      this.$router.push({
        name: 'campaignCreator',
        params: {
          messages: [
            {
              status: 'success',
              text: this.$t('templates.messages.template-saved-end-add-campaign', [template.name]),
            },
          ],
          campaignId: this.$route.params.campaignId,
          indexChannel: this.$route.params.indexChannel,
          template: {
            contentType: this.$route.params.contentType,
            id: template.emailTemplateId,
            name: template.name,
            thumbnailUri: template.thumbnailUri,
            htmlFileUri: template.htmlFileUri,
          },
        },
      })
    },

    templateCode() {
      return (this.code = this.template.code)
    },

    addCustomFieldsToText(text) {
      this.codemirrorInstance.focus()

      if (this.customField === null) {
        return
      }

      document.execCommand('insertText', false, '[' + text + '] ')
    },

    addSubscribeText(text) {
      this.codemirrorInstance.focus()

      document.execCommand('insertText', false, text)
    },
  },

  watch: {
    customField: function(newtext, oldText) {
      this.addCustomFieldsToText(newtext || oldText)
    },

    subscribeText: {
      handler(newtext) {
        this.addSubscribeText(newtext)
      },
    },

    selectedTheme: {
      handler(newValue) {
        if (newValue) {
          setItem('theme-html-editor', newValue)
        }
      },
      immediate: true,
    },

    modal: function() {
      this.insertHtmlInIframe(this.code)
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  box-shadow: none;
}

.editorhtml,
.card-header,
.card-footer {
  background: transparent;
  box-shadow: none !important;
  border: none;
}
</style>
